import { CourseType, SectionType } from "components/server-types";
import { t } from "i18n/i18n";

export const getCourseDisplayTitle = (course: Pick<CourseType, "code" | "title">): string => {
  if (course.title) {
    return t("common.course_code_and_title", {
      code: course.code,
      title: course.title,
    });
  }
  return course.code;
};

export const getCourseCodeAndSectionTitle = (
  course: Pick<CourseType, "code">,
  section: Pick<SectionType, "title">,
): string =>
  t("common.course_code_and_title", {
    code: course.code,
    title: section.title,
  });

export const getCourseAndSectionDisplayTitle = (
  course: Pick<CourseType, "code" | "title">,
  section: Pick<SectionType, "title">,
): string => {
  if (course.title) {
    return `${getCourseDisplayTitle(course)} - ${section.title}`;
  }
  return getCourseCodeAndSectionTitle(course, section);
};
